<template>
    <main class="main login">
        <div class="login-image">
            <img
                class="login-image-img"
                :src="require(`@/assets/img/${this.$brand.logo.welcomeImg}`)"
            />
        </div>
        <div class="container">
            <div class="row">
                <template v-if="setNewPassView === true">
                    <div class="col-md-6 offset-md-6 login-col">
                        <div class="ml-md-5 login-form w-75">
                            <h1 class="h3">Ustal nowe hasło</h1>
                            <p class="my-4">
                                Poniżej znajduje się formularz, który pozwoli Ci
                                ustanowić nowe hasło do Twojego konta.
                            </p>
                            <div>
                                Hasło powinno zawierać:
                                <ul>
                                    <li>przynajmniej 6 znaków</li>
                                    <li>co najmniej 1 małą literę</li>
                                    <li>co najmniej 1 wielką literę</li>
                                    <li>co najmniej 1 cyfrę</li>
                                    <li>
                                        co najmniej 1 znak specjalny (@$!%*?&)
                                    </li>
                                </ul>
                            </div>
                            <the-input
                                :type="'password'"
                                :label="'Nowe hasło'"
                                :name="'new-pass'"
                                :invalid="invalidNew"
                                :invalidFeedback="'Hasło nie spełnia wymagań.'"
                                @input="newPassword = $event"
                                :text="newPassword"
                            />
                            <the-input
                                :type="'password'"
                                :label="'Powtórz hasło'"
                                :name="'repeat-new-pass'"
                                :invalid="invalidRepeat"
                                :invalidFeedback="
                                    'Podane hasła nie są identyczne.'
                                "
                                @input="repeatNewPassword = $event"
                                :text="repeatNewPassword"
                            />
                            <the-btn
                                :btnClass="
                                    'mt-4 text-white btn-block btn-secondary'
                                "
                                @click.native="setNewPassword"
                                :text="'Ustal nowe hasło'"
                            ></the-btn>
                        </div>
                    </div>
                </template>
                <template v-if="setNewPassView === false">
                    <div
                        class="col-md-6 offset-md-6 login-col"
                        v-if="passResetView"
                    >
                        <div class="ml-md-5 login-form">
                            <h1 class="h3">Odzyskaj hasło</h1>
                            <p class="my-4">
                                Wyślemy instrukcję zmiany hasła na podany adres
                                e-mail:
                            </p>
                            <form @submit.prevent="sendResetPass">
                                <the-input
                                    class="cux-exclude"
                                    :type="'email'"
                                    :label="'Twój e-mail'"
                                    :name="'mp-email-reset'"
                                    @input="email = $event"
                                    :text="email"
                                />
                                <the-btn
                                    :btnClass="
                                        'mt-4 text-white btn-block btn-secondary'
                                    "
                                    :text="'Odzyskaj hasło'"
                                ></the-btn>
                            </form>
                            <p class="text-right mt-2">
                                <router-link to="/login"
                                    >Powrót do logowania</router-link
                                >
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 offset-md-6 login-col" v-else>
                        <div class="login-form">
                            <h1 class="h3 d-flex align-items-center">
                                <a-icon
                                    style="width: 36px; height: 36px"
                                    class="mr-2"
                                    icon="Check"
                                />Świetnie
                            </h1>
                            <p class="my-4">
                                Na podany adres e-mail wysłaliśmy instrukcję
                                zmiany hasła. Postępuj zgodnie z instrukcjami.
                            </p>
                            <router-link
                                class="btn btn-block text-white btn-secondary"
                                to="/login"
                                >Powrót do logowania</router-link
                            >
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    data() {
        return {
            initialPasswordMode: false,
            passResetView: true,
            setNewPassView: null,
            email: '',
            newPassword: '',
            repeatNewPassword: '',
            invalidRepeat: false,
            invalidNew: false
        }
    },
    created() {
        if (this.$route.path.includes('pass-new')) {
            this.setNewPassView = true
            this.initialPasswordMode = true
        } else if (this.$router.currentRoute.query.hash) {
            this.$store
                .dispatch('checkHash', this.$router.currentRoute.query.hash)
                .then(res => {
                    if (res) {
                        this.setNewPassView = true
                        this.email = res
                    } else {
                        this.$router.push({ name: 'pass-reset' })
                        this.setNewPassView = false
                    }
                })
        } else {
            this.setNewPassView = false
        }
    },
    methods: {
        backToLogin() {
            this.passResetView = false
        },
        sendResetPass() {
            this.$store
                .dispatch('sendResetPass', {
                    email: this.email,
                    redirect_url: `${window.location.origin}${
                        this.$router.resolve({ name: 'pass-reset' }).href
                    }/`
                })
                .then(res => {
                    if (res) {
                        this.passResetView = false
                        this.email = ''
                    }
                })
                .catch(e => console.log(e))
        },
        setNewPassword() {
            this.validateNewPassword(this.newPassword)
            this.validateRepeatPassword(this.repeatNewPassword)
            if (!this.invalidNew && !this.invalidRepeat) {
                const token = this.initialPasswordMode
                    ? this.$router.currentRoute.query.token
                    : this.$router.currentRoute.query.hash.split('token=')[1]

                const newPasswordRequestData = {
                    new_password: this.newPassword,
                    token: token
                }

                if (!this.initialPasswordMode) {
                    Object.assign(newPasswordRequestData, { email: this.email })
                }

                this.$store.dispatch('resetPass', newPasswordRequestData)
            }
        },
        validateNewPassword(value) {
            const validationResult =
                value.length > 0 &&
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@$%&?*]).{6,}$/.test(
                    value
                )
            this.invalidNew = !validationResult
        },
        validateRepeatPassword(value) {
            const validationResult =
                this.newPassword && this.newPassword === value
            this.invalidRepeat = !validationResult
        }
    }
}
</script>
